<template>
  <div class="myOrderDetail">
    <van-nav-bar
      :title="title"
      left-text=""
      left-arrow
      class="main-nav"
      fixed
      @click-left="onClickLeft"
    />
    <div
      class="myOrder_content"
      v-loading="loading"
      element-loading-text="数据加载中..."
    >
      <div class="myOrder_content_main">
        <img
          class="myOrder_content_main_fix"
          src="@/assets/images/setting/right.png"
          @click="showArea = true"
        />
        <van-form @submit="onSubmit">
          <van-field
            v-model="userName"
            name="contacts"
            label="收货人"
            placeholder="请输入收货人姓名"
            label-width="60px"
            :rules="[{ required: true, message: '请填写收货人姓名' }]"
          />
          <van-field
            v-model="phone"
            name="phone"
            label="电话号码"
            placeholder="请输入收货人电话"
            @input="phoneInput"
            label-width="60px"
            :rules="[
              {
                validator: this.phoneTest,
                required: true,
                trigger: 'onBlur',
                message: '请输入收货人电话',
              },
            ]"
          />
          <van-field
            label-width="60px"
            readonly
            clickable
            name="area"
            :value="value"
            label="所在地区"
            placeholder="省市区县、乡镇等"
            :rules="[{ required: true, message: '请输入所在地区' }]"
            @click="showArea = true"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-area
              :area-list="areaList"
              @confirm="onConfirm"
              @cancel="showArea = false"
            />
          </van-popup>
          <van-field
            label-width="60px"
            v-model="adressDetail"
            name="address"
            label="详细地址"
            placeholder="街道、楼牌号等"
            :rules="[{ required: true, message: '请输入详细地址' }]"
          />
          <van-field
            name="defaultFlag"
            label="设为默认收货地址"
            class="area"
            label-width="265px"
          >
            <template #input>
              <van-switch
                v-model="isSelect"
                size="22"
                active-color="#0DD6E0"
                inactive-color="#EBEBEB"
              />
            </template>
          </van-field>
          <div class="button">
            <van-button
              round
              block
              type="info"
              native-type="submit"
              style=" background: linear-gradient(180deg, #17E1EB 0%, #24BFFB 100%);:"
              >保存地址</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>
<script>
import { _addAddress, _addressDetail, _editAddress } from "../../api/setting";
import { areaList } from "@vant/area-data";
import { decryptBy, encryptBy } from "@/assets/js/encryption";
export default {
  name: "myOrderDetail",
  data() {
    return {
      userName: "", //收货人
      phone: "", //电话
      area: "", //所在地区
      isSelect: 0, //默认是否选中
      adressDetail: "", //详细地址
      title: "", //页面title
      areaList, //省市区数据
      value: "", //所在地址回显数据
      showArea: false, //选择省市区弹窗标识
      loading: false, //loading标识
      values: [], //选择的省市区列表
      id: "", //地址id
    };
  },
  created() {
    this.id = this.$route.query.id;
    if (this.id) {
      this.title = "编辑收货地址";
      this.getAddressDetail(this.id);
    } else {
      this.title = "新增收货地址";
    }
  },
  mounted() {},
  methods: {
    //手机号验证
    phoneTest() {
      var phone = this.phone.replaceAll(" ", "");
      var regex =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (regex.test(phone) || !phone) {
        return true;
      } else {
        return false;
      }
    },
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
    //保存地址
    onSubmit(values) {
      values.province = this.values[0].name;
      values.city = this.values[1].name;
      values.county = this.values[2].name;
      values.provinceCode = this.values[0].code;
      values.cityCode = this.values[1].code;
      values.countyCode = this.values[2].code;
      values.phone = encryptBy(values.phone.replace(/\s+/g, ""));
      values.defaultFlag = values.defaultFlag ? 1 : 0;
      if (this.id) {
        this.editAddress(this.id, values);
      } else {
        this.addAddress(values);
      }
    },
    //手机号加空格
    phoneInput() {
      let value = this.phone.replace(/\D/g, "").substr(0, 11);
      let len = value.length;
      if (len > 3 && len < 8) {
        value = value.replace(/^(\d{3})/g, "$1");
      } else if (len >= 8) {
        value = value.replace(/^(\d{3})(\d{4})/g, "$1 $2 ");
      }
      this.phone = value;
    },
    //省市区弹窗选择
    onConfirm(values) {
      this.value = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join(" ");
      this.values = values;
      this.showArea = false;
    },
    //编辑地址
    editAddress(data, val) {
      this.loading = true;
      _editAddress(data, val)
        .then((res) => {
          if (res && res.code == 200) {
            this.loading = false;
            this.onClickLeft();
          } else {
            Toast(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //保存地址
    addAddress(data) {
      this.loading = true;
      _addAddress(data)
        .then((res) => {
          if (res && res.code == 200) {
            this.loading = false;
            this.onClickLeft();
          } else {
            Toast(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //获取详情
    getAddressDetail(val) {
      this.loading = true;
      _addressDetail(val)
        .then((res) => {
          if (res && res.code == 200) {
            if (res.data) {
              let data = res.data;
              this.userName = data.contacts;
              this.phone = decryptBy(data.phone);
              this.value =
                data.province + "\xa0" + data.city + "\xa0" + data.county;
              this.adressDetail = data.address;
              this.isSelect = data.defaultFlag == 1 ? true : false;
              this.values.push({
                code: data.provinceCode,
                name: data.province,
              });
              this.values.push({ code: data.cityCode, name: data.city });
              this.values.push({ code: data.countyCode, name: data.county });
            }
            this.loading = false;
          } else {
            Toast(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.myOrderDetail {
  height: 100%;
  background: #fff;
  .main-nav {
    border-bottom: solid 1px #ebeef5;
  }
  .myOrder_content {
    padding-top: 48px;
    height: 100%;
    .myOrder_content_main {
      padding: 0 32px;
      position: relative;
      .myOrder_content_main_fix {
        width: 22px;
        position: fixed;
        right: 32px;
        top: 178px;
        z-index: 2000;
      }
    }
  }
  .area {
    display: flex;
    justify-content: space-between;
    border: none;
  }
  .button {
    margin-top: 50px;
  }
}
::v-deep.van-cell {
  padding: 16px 0px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #161515;
  border-bottom: solid 1px #ebeef5;
}
::v-deep.van-cell:after {
  border: none;
}
::v-deep.van-switch {
  border: 1px solid #ebebeb;
}
::v-deep.van-button {
  width: 335px;
  height: 44px;
  border-radius: 24px;
  text-align: center;
  line-height: 44px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  border: none;
  margin-left: -12px;
}
</style>
